import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FleetDistributionItem } from '../../../services/dashboardService';

interface FleetDistributionChartProps {
  data: FleetDistributionItem[];
}

/**
 * Composant pour afficher un graphique circulaire de la répartition des véhicules par flotte
 */
const FleetDistributionChart: React.FC<FleetDistributionChartProps> = ({ data }) => {
  const { t } = useTranslation('dashboard');
  const totalVehicles = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <Box sx={{ height: 300, position: 'relative' }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
            label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => [`${value} ${t('generalStats.totalVehicles').toLowerCase()}`, t('fleetDistribution.quantity')]}
            contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '8px' }}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <Typography variant="h4">{totalVehicles}</Typography>
      </Box>
    </Box>
  );
};

export default FleetDistributionChart;